/** @jsxImportSource @emotion/react */
import { Radio } from "antd";
import { radioGroupStyle } from "./NovaventaRadioCss";

type RadioProps = {
  onChange?: any;
  options: { id: string | number | boolean; label: string }[];
  defaultValue?: string | number;
  value?: string | number | boolean;
};

const NovaventaRadio = (props: RadioProps) => {
  const { onChange, options, defaultValue, value } = props;

  return (
    <Radio.Group
      options={options.map((option: any) => ({
        value: option.id,
        label: option.label
      }))}
      name="deliveryAddress"
      value={value}
      data-testid="nova-radio"
      defaultValue={defaultValue}
      onChange={onChange}
      css={radioGroupStyle}
    ></Radio.Group>
  );
};

export default NovaventaRadio;
